<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <div class="search_box">
        <el-input
          v-model="parameter.customer_name"
          placeholder="请输入客服名称"
          style="width: 200px; margin-right: 10px"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="dialogVisible = true"
        >创建</el-button>
      </div>
    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="客服id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="customer_name"
          label="客户名称"
          align="center"
        />
        <el-table-column
          prop="corp_name"
          label="企业名称"
          align="center"
        />
        <el-table-column
          prop="qrcode_img"
          label="二维码"
          align="center"
          width="180"
        >
          <template scope="scope">
            <el-popover
              placement="right"
              title="详情"
              width="280"
              trigger="hover"
            >
              <img
                :src="scope.row.qrcode_img"
                style="width: 250px"
              >
              <el-image
                v-if="scope.row.qrcode_img"
                slot="reference"
                style="width: 100px; height: 80px"
                :src="scope.row.qrcode_img"
                fit="scale-down"
              />
              <span v-else>暂无</span>
              <!-- <img v-if="scope.row.qrcode_img" slot="reference" :src="scope.row.qrcode_img" style="width: 100px; height: 80px">
              <span v-else>暂无</span> -->
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        >
          <template scope="scope">
            {{ timestampToTime(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
        >
          <template scope="scope">
            {{ timestampToTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="操作"
          min-width="180"
          align="center"
        >
          <template scope="scope">
            <div class="btn-wrap-box">
              <el-button
                type="warning"
                size="mini"
                @click="modifyItem(scope.row)"
              >修改</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteItem(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <el-dialog
      :title="JSON.stringify(currentItem) != '{}'? '修改' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <Details
        v-if="dialogVisible"
        :current-item="currentItem"
        @determine="determine"
        @close="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import Details from './components/details.vue'
import { enterpriseWeChatCustomerServiceList, enterpriseWeChatCustomerServiceAdded, enterpriseWeChatCustomerServiceModification, enterpriseWeChatCustomerServiceDelete } from '@/api/enterpriseWeChatCustomerService.js'
import timestampToTime from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    Details
  },
  mixins: [timestampToTime],
  data() {
    return {
      parameter: {
        customer_name: null,
        page: 1,
        pageSize: 10
      },
      tableData: {},
      loading: false,
      currentItem: {},
      dialogVisible: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      const data = await enterpriseWeChatCustomerServiceList(this.parameter)
      this.loading = false
      data.data.list = data.data.list.map(item => {
        return { ...item, qrcode_img: `${data.data.qcloud_domain + item.qrcode_img}` }
      })
      this.tableData = data.data
    },

    // 删除
    async deleteItem(row) {
      this.$confirm('该删除将会影响到 配置列表和错误列表 相关联的数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await enterpriseWeChatCustomerServiceDelete({ id: row.id })
        this.getList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 修改
    modifyItem(row) {
      this.dialogVisible = true
      this.currentItem = row
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.getList()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.customer_name = null
      this.getList()
    },

    // 确定
    async determine(from) {
      const bool = !!Object.keys(this.currentItem).length
      bool ? await enterpriseWeChatCustomerServiceModification({ id: this.currentItem.id, ...from }) : await enterpriseWeChatCustomerServiceAdded(from)
      this.getList()
      this.currentItem = {}
      this.dialogVisible = false
      this.$message({
        message: bool ? '修改成功' : '创建成功',
        type: 'success'
      })
    },

    handleClose(done) {
      this.dialogVisible = false
      this.currentItem = {}
    },

    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    }
  }
}
</script>

<style scoped>
.configurationList {
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
}

.configurationList_selectionArea {
  display: flex;
  gap:10px;
  align-items: center;
  justify-content: space-between;
}

.configurationList_main {
  margin-top: 30px;
}
</style>
